import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from '../../../model/guru-entity';
import {ModelService} from '../../../services/model-service';
import {SelectionUtils} from '../../selection-utils';
import {ConfigurationSection, UserStateService} from '../../../services/user-state.service';
import { FormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-ddbc-controls',
    templateUrl: './ddbc-controls.component.html',
    styleUrls: ['./ddbc-controls.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, FormsModule]
})
export class DdbcControlsComponent implements OnChanges {
  private modelService = inject(ModelService);
  private userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  controlVoltageSelection!: GuruEntity;
  controlTypeSelection!: GuruEntity;
  condensateSwitchSelection!: GuruEntity;
  serviceLightSelection!: GuruEntity;
  thermostatTypeSelection!: GuruEntity;
  skyportServiceSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.CONTROLS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.controlVoltageSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USControlVoltage');
    this.controlTypeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USControlType');
    this.condensateSwitchSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCondensateSwitch');
    this.serviceLightSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USServiceLight');
    this.thermostatTypeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USThermostat');
    this.skyportServiceSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSkyportSetupService');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
